import { render, staticRenderFns } from "./forIos.vue?vue&type=template&id=0a3bcdf2&scoped=true"
import script from "./forIos.vue?vue&type=script&lang=js"
export * from "./forIos.vue?vue&type=script&lang=js"
import style0 from "./forIos.vue?vue&type=style&index=0&id=0a3bcdf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3bcdf2",
  null
  
)

export default component.exports